unit unit_AuftragUnterschriften;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, Vcl.StdCtrls, WEBLib.StdCtrls,
  VCL.TMSFNCCustomControl, VCL.TMSFNCSignatureCapture, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.SignatureCapture;

type
  TAuftragUnterschriften = class(TForm)
    panelmonteur: TPanel;
    dsUnterschriften: TXDataWebDataSet;
    dsUnterschriftenNummerkomplett: TStringField;
    dsUnterschriftenDatum: TDateTimeField;
    dsUnterschriftenUnterschriftMonteur: TBlobField;
    dsUnterschriftenUnterschriftKunde: TBlobField;
    dsUnterschriftenUnterschriftMonteurText: TStringField;
    dsUnterschriftenUnterschriftKundeText: TStringField;
    sourceUnterschriften: TDataSource;
    WebLabel1: TLabel;
    WebEdit1: TEdit;
    dsUnterschriftenNachnameKunde: TStringField;
    dsUnterschriftenNachnameMonteur: TStringField;
    Container1: THTMLContainer;
    btnUAbbrechen: TButton;
    btnUSpeichern: TButton;
    Container2: THTMLContainer;
    panelkunde: TPanel;
    WebLabel3: TLabel;
    WebEdit2: TEdit;
    SigMonteur: TSignatureCapture;
    SigKunde: TSignatureCapture;
    procedure btnUSpeichernClick(Sender: TObject);
    procedure btnUAbbrechenClick(Sender: TObject);
    procedure dsUnterschriftenAfterPost(DataSet: TDataSet);
    procedure dsUnterschriftenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    UMerkerAuftrag:string;
  protected procedure LoadDFMValues; override; end;

var
  AuftragUnterschriften: TAuftragUnterschriften;

implementation
  uses unit1, unit2, unit_Einzelauftrag;
{$R *.dfm}

procedure TAuftragUnterschriften.btnUAbbrechenClick(Sender: TObject);
begin
  self.Close;
end;

procedure TAuftragUnterschriften.btnUSpeichernClick(Sender: TObject);
begin
  dsunterschriften.Append;
  dsUnterschriftenNummerkomplett.AsString:=UMerkerAuftrag;
  dsUnterschriftenDatum.AsDateTime:=date+time;
//WebImageControl1.URL := TMSFNCSignatureCapture1.GetBase64Img;
//WebDBImageControl1.Base64Image := TMSFNCSignatureCapture1.GetBase64Img;
  dsUnterschriftenUnterschriftMonteurText.asstring:=sigmonteur.GetAsBase64Image;
  dsUnterschriftenUnterschriftKundeText.AsString:=sigkunde.GetAsBase64Image;
  dsUnterschriftenNachnameMonteur.AsString:=WebEdit1.Text;
  dsUnterschriftenNachnameKunde.AsString:=WebEdit2.Text;
  dsUnterschriften.Post;

end;

procedure TAuftragUnterschriften.dsUnterschriftenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
begin
  self.Close;
end;

procedure TAuftragUnterschriften.dsUnterschriftenAfterPost(DataSet: TDataSet);
begin
  if LizenzOK then
  begin
    dsUnterschriften.ApplyUpdates;
  end
  else
  begin
    showmessage('Für das Speichern von Daten sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
  end;
end;

procedure TAuftragUnterschriften.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Unterschriften Auftrag '+UMerkerAuftrag+'</h5></nav>';
  myelement:=container1.ElementHandle;
  btnUAbbrechen.ParentElement:=myelement;
  btnUSpeichern.ParentElement:=myelement;

  myelement:=container2.elementhandle;
  panelMonteur.parentelement:=myelement;
  panelKunde.parentelement:=myelement;

  myelement:=panelMonteur.elementhandle;
  sigmonteur.ParentElement:=myelement;
  weblabel1.ParentElement:=myelement;
  webedit1.ParentElement:=myelement;

  myelement:=panelkunde.elementhandle;
  sigkunde.ParentElement:=myelement;
  weblabel3.ParentElement:=myelement;
  webedit2.ParentElement:=myelement;

  dsUnterschriften.Close;
  dsUnterschriften.QueryString:='$filter=Nummerkomplett eq '+QuotedStr(UMerkerAuftrag);
  dsUnterschriften.Load;
end;

procedure TAuftragUnterschriften.LoadDFMValues;
begin
  inherited LoadDFMValues;

  panelmonteur := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  SigMonteur := TSignatureCapture.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  btnUAbbrechen := TButton.Create(Self);
  btnUSpeichern := TButton.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  panelkunde := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  SigKunde := TSignatureCapture.Create(Self);
  dsUnterschriften := TXDataWebDataSet.Create(Self);
  dsUnterschriftenNummerkomplett := TStringField.Create(Self);
  dsUnterschriftenDatum := TDateTimeField.Create(Self);
  dsUnterschriftenUnterschriftMonteur := TBlobField.Create(Self);
  dsUnterschriftenUnterschriftKunde := TBlobField.Create(Self);
  dsUnterschriftenUnterschriftMonteurText := TStringField.Create(Self);
  dsUnterschriftenUnterschriftKundeText := TStringField.Create(Self);
  dsUnterschriftenNachnameKunde := TStringField.Create(Self);
  dsUnterschriftenNachnameMonteur := TStringField.Create(Self);
  sourceUnterschriften := TDataSource.Create(Self);

  panelmonteur.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  SigMonteur.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  btnUAbbrechen.BeforeLoadDFMValues;
  btnUSpeichern.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  panelkunde.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  SigKunde.BeforeLoadDFMValues;
  dsUnterschriften.BeforeLoadDFMValues;
  dsUnterschriftenNummerkomplett.BeforeLoadDFMValues;
  dsUnterschriftenDatum.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftMonteur.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftKunde.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftMonteurText.BeforeLoadDFMValues;
  dsUnterschriftenUnterschriftKundeText.BeforeLoadDFMValues;
  dsUnterschriftenNachnameKunde.BeforeLoadDFMValues;
  dsUnterschriftenNachnameMonteur.BeforeLoadDFMValues;
  sourceUnterschriften.BeforeLoadDFMValues;
  try
    Name := 'AuftragUnterschriften';
    Width := 348;
    Height := 682;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    ElementPosition := epIgnore;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    panelmonteur.SetParentComponent(Self);
    panelmonteur.Name := 'panelmonteur';
    panelmonteur.Left := 0;
    panelmonteur.Top := 133;
    panelmonteur.Width := 313;
    panelmonteur.Height := 270;
    panelmonteur.ElementClassName := 'card m-1 border-info bg-info';
    panelmonteur.BorderStyle := bsNone;
    panelmonteur.Caption := 'panelMonteur';
    panelmonteur.Color := 12557152;
    panelmonteur.ElementFont := efCSS;
    panelmonteur.ElementPosition := epIgnore;
    panelmonteur.ShowCaption := False;
    WebLabel1.SetParentComponent(panelmonteur);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 3;
    WebLabel1.Top := 195;
    WebLabel1.Width := 120;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Name ausgeschrieben:';
    WebLabel1.ElementClassName := 'text-sm';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epIgnore;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthStyle := ssPercent;
    WebLabel1.WidthPercent := 98.000000000000000000;
    WebEdit1.SetParentComponent(panelmonteur);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 3;
    WebEdit1.Top := 216;
    WebEdit1.Width := 295;
    WebEdit1.Height := 23;
    WebEdit1.AutoSize := True;
    WebEdit1.ChildOrder := 4;
    WebEdit1.ElementClassName := 'form-control';
    WebEdit1.ElementFont := efCSS;
    WebEdit1.ElementPosition := epIgnore;
    WebEdit1.HeightStyle := ssAuto;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.TextHint := 'Name Monteur/Techniker';
    WebEdit1.WidthStyle := ssPercent;
    WebEdit1.WidthPercent := 98.000000000000000000;
    SigMonteur.SetParentComponent(panelmonteur);
    SigMonteur.Name := 'SigMonteur';
    SigMonteur.Left := 3;
    SigMonteur.Top := 3;
    SigMonteur.Width := 299;
    SigMonteur.Height := 186;
    SigMonteur.ElementClassName := 'form-control';
    SigMonteur.WidthStyle := ssPercent;
    SigMonteur.WidthPercent := 98.000000000000000000;
    SigMonteur.ChildOrder := 2;
    SigMonteur.ElementPosition := epIgnore;
    SigMonteur.TabOrder := 1;
    SigMonteur.TextPosition.Line.Color := clGray;
    SigMonteur.Text := 'Unterschrift Monteur/Techniker';
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 8;
    Container1.Width := 225;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    btnUAbbrechen.SetParentComponent(Self);
    btnUAbbrechen.Name := 'btnUAbbrechen';
    btnUAbbrechen.Left := 0;
    btnUAbbrechen.Top := 102;
    btnUAbbrechen.Width := 104;
    btnUAbbrechen.Height := 25;
    btnUAbbrechen.Caption := 'Abbrechen';
    btnUAbbrechen.ChildOrder := 3;
    btnUAbbrechen.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnUAbbrechen.ElementFont := efCSS;
    btnUAbbrechen.ElementPosition := epIgnore;
    btnUAbbrechen.HeightStyle := ssAuto;
    btnUAbbrechen.HeightPercent := 100.000000000000000000;
    btnUAbbrechen.WidthStyle := ssAuto;
    btnUAbbrechen.WidthPercent := 100.000000000000000000;
    SetEvent(btnUAbbrechen, Self, 'OnClick', 'btnUAbbrechenClick');
    btnUSpeichern.SetParentComponent(Self);
    btnUSpeichern.Name := 'btnUSpeichern';
    btnUSpeichern.Left := 110;
    btnUSpeichern.Top := 102;
    btnUSpeichern.Width := 105;
    btnUSpeichern.Height := 25;
    btnUSpeichern.Caption := 'speichern';
    btnUSpeichern.ChildOrder := 4;
    btnUSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnUSpeichern.ElementFont := efCSS;
    btnUSpeichern.ElementPosition := epIgnore;
    btnUSpeichern.HeightStyle := ssAuto;
    btnUSpeichern.HeightPercent := 100.000000000000000000;
    btnUSpeichern.WidthStyle := ssAuto;
    btnUSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnUSpeichern, Self, 'OnClick', 'btnUSpeichernClick');
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 55;
    Container2.Width := 225;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    panelkunde.SetParentComponent(Self);
    panelkunde.Name := 'panelkunde';
    panelkunde.Left := 0;
    panelkunde.Top := 404;
    panelkunde.Width := 313;
    panelkunde.Height := 270;
    panelkunde.ElementClassName := 'card m-1 border-info bg-info';
    panelkunde.BorderStyle := bsNone;
    panelkunde.Caption := 'panelKunde';
    panelkunde.ChildOrder := 7;
    panelkunde.Color := 12557152;
    panelkunde.ElementFont := efCSS;
    panelkunde.ElementPosition := epIgnore;
    panelkunde.ShowCaption := False;
    WebLabel3.SetParentComponent(panelkunde);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 3;
    WebLabel3.Top := 195;
    WebLabel3.Width := 120;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Name ausgeschrieben:';
    WebLabel3.ElementClassName := 'text-sm';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.ElementPosition := epIgnore;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthStyle := ssPercent;
    WebLabel3.WidthPercent := 98.000000000000000000;
    WebEdit2.SetParentComponent(panelkunde);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 3;
    WebEdit2.Top := 216;
    WebEdit2.Width := 295;
    WebEdit2.Height := 23;
    WebEdit2.AutoSize := True;
    WebEdit2.ChildOrder := 4;
    WebEdit2.ElementClassName := 'form-control';
    WebEdit2.ElementFont := efCSS;
    WebEdit2.ElementPosition := epIgnore;
    WebEdit2.HeightStyle := ssAuto;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.TextHint := 'Name des Kunden';
    WebEdit2.WidthStyle := ssPercent;
    WebEdit2.WidthPercent := 98.000000000000000000;
    SigKunde.SetParentComponent(panelkunde);
    SigKunde.Name := 'SigKunde';
    SigKunde.Left := 6;
    SigKunde.Top := 11;
    SigKunde.Width := 299;
    SigKunde.Height := 186;
    SigKunde.ElementClassName := 'form-control';
    SigKunde.WidthStyle := ssPercent;
    SigKunde.WidthPercent := 98.000000000000000000;
    SigKunde.ChildOrder := 2;
    SigKunde.ElementPosition := epIgnore;
    SigKunde.TabOrder := 1;
    SigKunde.TextPosition.Line.Color := clGray;
    SigKunde.Text := 'Unterschrift Kunde';
    dsUnterschriften.SetParentComponent(Self);
    dsUnterschriften.Name := 'dsUnterschriften';
    dsUnterschriften.AfterApplyUpdates := dsUnterschriftenAfterApplyUpdates;
    dsUnterschriften.AfterPost := dsUnterschriftenAfterPost;
    dsUnterschriften.EntitySetName := 'AuftragUnterschriften';
    dsUnterschriften.Connection := DM2.XDataWebConnection1;
    dsUnterschriften.Left := 252;
    dsUnterschriften.Top := 96;
    dsUnterschriftenNummerkomplett.SetParentComponent(dsUnterschriften);
    dsUnterschriftenNummerkomplett.Name := 'dsUnterschriftenNummerkomplett';
    dsUnterschriftenNummerkomplett.FieldName := 'Nummerkomplett';
    dsUnterschriftenNummerkomplett.Required := True;
    dsUnterschriftenNummerkomplett.Size := 10;
    dsUnterschriftenDatum.SetParentComponent(dsUnterschriften);
    dsUnterschriftenDatum.Name := 'dsUnterschriftenDatum';
    dsUnterschriftenDatum.FieldName := 'Datum';
    dsUnterschriftenUnterschriftMonteur.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftMonteur.Name := 'dsUnterschriftenUnterschriftMonteur';
    dsUnterschriftenUnterschriftMonteur.FieldName := 'UnterschriftMonteur';
    dsUnterschriftenUnterschriftKunde.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftKunde.Name := 'dsUnterschriftenUnterschriftKunde';
    dsUnterschriftenUnterschriftKunde.FieldName := 'UnterschriftKunde';
    dsUnterschriftenUnterschriftMonteurText.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftMonteurText.Name := 'dsUnterschriftenUnterschriftMonteurText';
    dsUnterschriftenUnterschriftMonteurText.FieldName := 'UnterschriftMonteurText';
    dsUnterschriftenUnterschriftMonteurText.Size := 255;
    dsUnterschriftenUnterschriftKundeText.SetParentComponent(dsUnterschriften);
    dsUnterschriftenUnterschriftKundeText.Name := 'dsUnterschriftenUnterschriftKundeText';
    dsUnterschriftenUnterschriftKundeText.FieldName := 'UnterschriftKundeText';
    dsUnterschriftenUnterschriftKundeText.Size := 255;
    dsUnterschriftenNachnameKunde.SetParentComponent(dsUnterschriften);
    dsUnterschriftenNachnameKunde.Name := 'dsUnterschriftenNachnameKunde';
    dsUnterschriftenNachnameKunde.FieldName := 'NachnameKunde';
    dsUnterschriftenNachnameKunde.Size := 50;
    dsUnterschriftenNachnameMonteur.SetParentComponent(dsUnterschriften);
    dsUnterschriftenNachnameMonteur.Name := 'dsUnterschriftenNachnameMonteur';
    dsUnterschriftenNachnameMonteur.FieldName := 'NachnameMonteur';
    dsUnterschriftenNachnameMonteur.Size := 50;
    sourceUnterschriften.SetParentComponent(Self);
    sourceUnterschriften.Name := 'sourceUnterschriften';
    sourceUnterschriften.DataSet := dsUnterschriften;
    sourceUnterschriften.Left := 256;
    sourceUnterschriften.Top := 36;
  finally
    panelmonteur.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    SigMonteur.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    btnUAbbrechen.AfterLoadDFMValues;
    btnUSpeichern.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    panelkunde.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    SigKunde.AfterLoadDFMValues;
    dsUnterschriften.AfterLoadDFMValues;
    dsUnterschriftenNummerkomplett.AfterLoadDFMValues;
    dsUnterschriftenDatum.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftMonteur.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftKunde.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftMonteurText.AfterLoadDFMValues;
    dsUnterschriftenUnterschriftKundeText.AfterLoadDFMValues;
    dsUnterschriftenNachnameKunde.AfterLoadDFMValues;
    dsUnterschriftenNachnameMonteur.AfterLoadDFMValues;
    sourceUnterschriften.AfterLoadDFMValues;
  end;
end;

end.
